export const getDeliveryName = (key: string) => {
  if (key.startsWith('ACLUPD')) {
    return 'Изменение ТТ';
  }
  if (key.startsWith('ACL')) {
    return 'Новая ТТ';
  }
  if (key.startsWith('CE')) {
    return 'Сканивание ХО';
  }
  if (key.startsWith('RE')) {
    return 'Заявка на сервисный обслуживание ХО';
  }
  if (key.startsWith('IE')) {
    return 'Установка ХО';
  }
  if (key.startsWith('UE')) {
    return 'Снятие ХО';
  }
  if (key.startsWith('OV')) {
    return 'Визит в ТТ';
  }
  if (key.startsWith('TEST')) {
    return 'Test';
  }
  return 'Неизвестно';
};

// new   ->   opened -> ready -> transferred -> closed cancelled _error
export const getDeliveryStatus = (status: string) => {
  if (status === 'new') {
    return 'Новая';
  }
  if (status === 'opened') {
    return 'Открыта';
  }
  if (status === 'ready') {
    return 'Готова к передаче';
  }
  if (status === 'transferred') {
    return 'Передана';
  }
  if (status === 'closed') {
    return 'Закрыта';
  }
  if (status === 'cancelled') {
    return 'Отменена';
  }
  if (status === '_error') {
    return 'Ошибка';
  }
  return 'Неизвестно';
};

export const getDeliveryEntityID = (key: string) => {
  if (key.startsWith('ACLUPD')) {
    return 'ИНН ТТ';
  }
  if (key.startsWith('ACL')) {
    return 'ИНН ТТ';
  }
  if (key.startsWith('CE')) {
    return 'Серийный номер ХО';
  }
  if (key.startsWith('RE')) {
    return 'Серийный номер ХО';
  }
  if (key.startsWith('IE')) {
    return 'ID ТТ';
  }
  if (key.startsWith('UE')) {
    return 'Серийный номер ХО';
  }
  if (key.startsWith('OV')) {
    return 'ID ТТ';
  }
  if (key.startsWith('TEST')) {
    return 'Timestamp';
  }
  return 'Неизвестно';
};